import CreatingJobs from "../components/CreatingJobs";
import NavBar from "../components/Nav";
const CreateJobs = () => {
	return (
		<>
			<NavBar />
			<CreatingJobs />
		</>
	);
};

export default CreateJobs;
